export default function fullpageInit() {
  let fullpageInstance = new fullpage('#fullpage', {
    licenseKey: 'YKCHI-NM7NI-IV586-4N987-MJCLN',
    autoScrolling: true,
    scrollHorizontally: true,
    scrollingSpeed: 1000,
    credits: false,

    afterRender: function () {
      document
        .querySelector('.section-content .wire .animated')
        .classList.add('wire-down');
      document.querySelector('.section-content').classList.add('displayed');
      window.splideImg.mount();
      window.splideWord.mount();
    },
    beforeLeave: function (origin, destination, direction, trigger) {
      if (direction === 'down') {
        if (
          origin.item.querySelector('.wire .animated') &&
          destination.item.querySelector('.wire .animated')
        ) {
          origin.item
            .querySelector('.wire .animated')
            .classList.remove('wire-down');
          origin.item
            .querySelector('.wire .animated ')
            .classList.remove('wire-up');
          destination.item
            .querySelector('.wire .animated')
            .classList.remove('wire-down');
          destination.item
            .querySelector('.wire .animated')
            .classList.remove('wire-up');
          destination.item
            .querySelector('.wire .animated')
            .classList.add('wire-down');
        }

        if (destination.index === 2) {
          window.lottieAnimation.play();
        }
      } else {
        if (
          origin.item.querySelector('.wire .animated') &&
          destination.item.querySelector('.wire .animated')
        ) {
          origin.item
            .querySelector('.wire .animated')
            .classList.remove('wire-down');
          origin.item
            .querySelector('.wire .animated')
            .classList.remove('wire-up');
          origin.item.querySelector('.wire .animated').classList.add('wire-up');
        }
      }

      if (destination.index === 1) {
        setTimeout(() => {
          if (window.splideImg && window.splideWord) {
            window.splideImg.i.Autoplay.play();
            window.splideWord.i.Autoplay.play();
          }
        }, 1000);
      } else {
        setTimeout(() => {
          if (window.splideImg && window.splideWord) {
            window.splideImg.go(0);
            window.splideImg.i.Autoplay.pause();
            window.splideWord.go(0);
            window.splideWord.i.Autoplay.pause();
          }
        }, 400);
      }
    },
  });
}
